import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';
import { IoIosArrowBack } from 'react-icons/io';

const LoginView: React.FC = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the redirect path from state or default to home
  const from = location.state?.from?.pathname || '/';

  const handleGoogleSuccess = (response: CredentialResponse) => {
    // Pass the redirect path to signIn
    signIn(response, from);
    // The page will reload after sign-in due to the implementation in AuthContext
    // After reload, we'll redirect to the original page
  };

  const handleGoogleError = () => {
    console.error('Google login failed');
  };

  const handleReturn = () => {
    // Use the browser's back navigation
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md">
        <div className="flex justify-between items-center mb-6">
          <button
            onClick={handleReturn}
            className="flex items-center text-stone-600 hover:text-stone-800"
            aria-label="Return"
          >
            <IoIosArrowBack className="mr-1" /> Return
          </button>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-stone-800 mb-2">Welcome to Nexus</h1>
          <p className="text-stone-600">Sign in to continue</p>
        </div>

        <div className="space-y-6">
          <div className="flex flex-col items-center">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap
              shape="rectangular"
              theme="outline"
              text="signin_with"
              size="large"
            />
          </div>
        </div>

        <details className="mt-8 text-sm text-stone-500">
          <summary className="cursor-pointer text-center hover:text-stone-700 my-4">
            Privacy & data use
          </summary>
          <div className="mt-2 text-left text-xs bg-stone-100 px-4 py-1 rounded">
            <p>When you sign in with Google, we receive your email address, which we use solely to identify you within the app. It is not visible to other users. We do not sell or share your data with third parties.</p>
          </div>
        </details>
      </div>
    </div>
  );
};

export default LoginView;
